import { InvoiceServiceInterface } from "interfaces/invoice-service";
import { BaseBusinessService } from "services/mms/external-api/business/base-business-service"

export class BusinessInvoiceService
    extends BaseBusinessService
    implements InvoiceServiceInterface 
{
    useGetLastInvoice() {
        return this.get({endpoint: `/invoices`})
    }
    useGetListInvoices() {
        return this.get({ endpoint: `/invoices` })
    }
}